module.exports = __webpack_public_path__ + "daf1e69f23a866253d21be9872aa3694.png";